import { takeLatest, all, put } from 'redux-saga/effects';
import * as calls from './calls';
import * as reducerActions from '../../reducers/marcasReducer/actions';
import * as Notifications from '../../components/Common/notification';
import * as layoutActions from '../../reducers/layoutReducer/actions';

function* genGetAllMarcas() {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo marcas' }));
        let marcas = yield calls.GetAllMarcas();
        yield put(reducerActions.setMarcas(marcas));
    } catch (error) {
        if (error.Message) {
            return;
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetMarca(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando marca' }));
        let marca = yield calls.getMarca(e.payload.idMarca);
        yield put(reducerActions.saveMarca(marca));
    } catch (error) {
        if (error.message) {
            return;
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetMarcaByCodigo(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando marca' }));
        let marca = yield calls.getMarcaByCodigo(e.payload.codigo);
        yield put(reducerActions.saveMarca(marca));
    } catch (error) {
        if (error.Message) {
            return;
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetMarcaByNombre(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando marca' }));
        let marca = yield calls.getMarcaByNombre(e.payload.nombre);
        yield put(reducerActions.saveMarca(marca));
    } catch (error) {
        if (error.Message) {
            return;
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genSaveMarca(e) {
    try {
        yield calls.saveMarca(e.payload);
        if (e.payload.idMarca !== 0) {
            Notifications.showSuccess("Marca actualizada");
        } else {
            Notifications.showSuccess("Marca creada");
        }
        window.history.back();
    } catch (e) {
        Notifications.showError(e.error);
    }
}

function* genDeleteMarca(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Eliminando marca' }));
        yield calls.deleteMarca(e.payload.idMarca);
        yield put(layoutActions.setLoading({ show: false }));
        Notifications.showSuccess("Marca eliminada");
        yield put(reducerActions.sagaGetMarcas());
    } catch (error) {
        yield put(layoutActions.setLoading({ show: false }));
        Notifications.showError(error.message || "Error al eliminar la marca");
    }
}

function* defaultSaga() {
    yield all([
        takeLatest(reducerActions.SAGA_GET_MARCAS, genGetAllMarcas),
        takeLatest(reducerActions.SAGA_GET_MARCA, genGetMarca),
        takeLatest(reducerActions.SAGA_GET_MARCA_BY_CODIGO, genGetMarcaByCodigo),
        takeLatest(reducerActions.SAGA_GET_MARCA_BY_NOMBRE, genGetMarcaByNombre),
        takeLatest(reducerActions.SAGA_SAVE_MARCA, genSaveMarca),
        takeLatest(reducerActions.SAGA_ELIMINAR_MARCA, genDeleteMarca),
    ]);
}

export const sagas = [
    defaultSaga
];